module.exports = __webpack_public_path__ + "img/zx6.58361d86.png";